package org.catharsis.spendtel.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import org.catharsis.spendtel.core.api.AnalyticsApi
import org.catharsis.spendtel.feature.data.EventName
import org.catharsis.spendtel.feature.presentation.expensereport.SpendTelReportColors
import org.koin.compose.koinInject

@Composable
fun LegalLinks(
    onPrivacyClick: () -> Unit = {},
    onTermsClick: () -> Unit = {},
) {
    val analytics = koinInject<AnalyticsApi>()

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(16.dp),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceEvenly,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Text(
                text = "Privacy Policy",
                style = MaterialTheme.typography.bodyMedium,
                color = SpendTelReportColors.violet,
                fontWeight = FontWeight.Medium,
                textDecoration = TextDecoration.Underline,
                modifier = Modifier.clickable {
                    analytics.logClickEvent(EventName.CLICKED_PRIVACY)
                    onPrivacyClick()
                },
            )

            Text(
                text = "Terms & Conditions",
                style = MaterialTheme.typography.bodyMedium,
                color = SpendTelReportColors.violet,
                fontWeight = FontWeight.Medium,
                textDecoration = TextDecoration.Underline,
                modifier = Modifier.clickable {
                    analytics.logClickEvent(EventName.CLICKED_TERMS)
                    onTermsClick()
                },
            )
        }
    }
}
